import { TableHeaderColumn } from '@/modules/drivers/types/table'

export const getCompaniesTableColumns = (t: (key: string) => string): TableHeaderColumn[] => [
  {
    title: t('addCompany.companyName'),
    key: 'companyName',
    type: 'string',
    sort: true,
  },
  {
    title: t('addCompany.identifier'),
    key: 'uniqueIdentifier',
    type: 'string',
    sort: true,
  },
  {
    title: t('addCompany.updateStatus'),
    key: 'isValid',
    type: 'string',
    sort: true,
  },
  {
    title: t('common.status'),
    key: 'isActive',
    type: 'string',
    sort: true,
  },
  {
    title: t('addCompany.createdDate'),
    key: 'createdDate',
    type: 'date',
    sort: true,
  },
  {
    title: t('addCompany.dbSize'),
    key: null,
    type: 'string',
    sort: false,
  },
  {
    title: '',
    key: null,
    type: 'string',
    sort: false,
  },
]

// Keep backward-compatible export
export const CompaniesTableColumns: TableHeaderColumn[] = [
  { title: 'Nazwa firmy', key: 'companyName', type: 'string', sort: true },
  { title: 'Identyfikator', key: 'uniqueIdentifier', type: 'string', sort: true },
  { title: 'Status aktualizacji', key: 'isValid', type: 'string', sort: true },
  { title: 'Status', key: 'isActive', type: 'string', sort: true },
  { title: 'Data utworzenia', key: 'createdDate', type: 'date', sort: true },
  { title: 'Rozmiar', key: null, type: 'string', sort: false },
]
